"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const SwiperRendererWrapper_1 = __importDefault(require("./components/SwiperRendererWrapper"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const controlChildrenArrayToComponent_1 = __importDefault(require("../../../shared/controlChildrenArrayToComponent"));
const SwiperRender = ({ swiperControl, }) => {
    const events = (0, useControlEvents_1.default)(swiperControl);
    (0, useOnLoad_1.default)(swiperControl, events);
    return (react_1.default.createElement(SwiperRendererWrapper_1.default, { control: swiperControl }, (0, controlChildrenArrayToComponent_1.default)(swiperControl.controls)));
};
exports.default = SwiperRender;
